import Vue from 'vue'
import Resource from 'vue-resource'
import store from '@/store'
Vue.use(Resource)

export default {
	findAll (params = {}) {
		return new Promise(function (resolve, reject) {
			Vue.http.get(store.state.apiURL + '/v1/products', {params: params}).then(function (response) {
				resolve(response.body)
			}, function (response) {
				reject(response)
			})
		})
	},
	findOne (id, params = {}) {
		return new Promise(function (resolve, reject) {
			Vue.http.get(store.state.apiURL + '/v1/products/' + id, {params: params}).then(function (response) {
				resolve(response.body)
			}, function (response) {
				reject(response)
			})
		})
	},
	getAllProductTypes () {
		return new Promise(function (resolve, reject) {
			Vue.http.get(store.state.apiURL + '/v1/product/types', {}).then(function (response) {
				resolve(response.body)
			}, function (response) {
				reject(response)
			})
		})
	},
	/**
	 * @param {number} id
	 */
	getProductById (id) {
		return new Promise(function (resolve, reject) {
			Vue.http.get(store.state.apiURL + '/v1/products/' + id, {}).then(function (response) {
				resolve(response.body)
			}, function (response) {
				reject(response)
			})
		})
	},
	/**
	 * @param {number} id
	 */
	getProductsByTypeId (id, params = {}) {
		params.type_id = id
		return new Promise(function (resolve, reject) {
			Vue.http.get(store.state.apiURL + '/v1/products', {
				params: params
			}).then(function (response) {
				resolve(response.body)
			}, function (response) {
				reject(response)
			})
		})
	},
	getProductTypeParent (id) {
		return new Promise(function (resolve, reject) {
			Vue.http.get(store.state.apiURL + '/v1/product/types', {
				params: {
					type_id: id,
					flag: 'parent'
				}
			}).then(function (response) {
				resolve(response.body)
			}, function (response) {
				reject(response)
			})
		})
	},
	update (id, data = {}) {
		return new Promise(function (resolve, reject) {
			Vue.http.put(store.state.apiURL + '/v1/products/' + id, data).then(function (response) {
				resolve(response.body)
			}, function (response) {
				reject(response)
			})
		})
	}
}



// WEBPACK FOOTER //
// ./src/api/modules/product/product.js